/* eslint-disable @typescript-eslint/no-explicit-any */
import { ActionTree } from 'vuex';
import axios from 'axios';
import { RootState, SkillProf, SkillProfState } from './learner-types';

const actions: ActionTree<SkillProfState, RootState> = {
  async fetchInitialData({ commit }, skillProfId) {
    console.log('skill and proficiency parameter', skillProfId.skill_id, skillProfId.proficiency_id);
    await axios
      .post('http://localhost:3000/local/genome-solidify-api-svc/learner/journey/stat', { skill_id: skillProfId.skill_id, proficiency_id: skillProfId.proficiency_id, learner_key: '850048454' })
      .then((response: any) => {
        const res = response.data;
        // console.log('Api Response', res);
        const payload: SkillProf = {
          skillName: res.skill,
          ProfName: res.proficiency,
          learnerData: res.learnerData,
        };
        // console.log(learnerData);
        console.log('payload', payload.learnerData);
        commit('SkillProfInState', payload);
      })
      .catch((err) => {
        console.log('Fetch User Data', err);
        commit('SkillProfError');
      });
  },
};

export default actions;
